import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SHARED_MODULES } from '../../../shared.';

export interface LinksPosition {
    position: string,
    coordinates: { x: number, y: number }
}

@Component({
    selector: 'app-dropdown-links',
    templateUrl: './dropdown-links.component.html',
    styleUrls: ['./dropdown-links.component.scss'],
	imports: [SHARED_MODULES],
    standalone: true
})

export class DropdownLinksComponent implements OnInit {

    tempInit: boolean = false;
    planogramQuery: string = '';
    filteredPlanogram: any = [];
    standChoose: boolean = false;
    position: LinksPosition = { position: 'bottom', coordinates: { x: 0, y: 0 } };

    constructor(private ERef: ElementRef) {}

    clickOut = (event: Event) => {
        if(this.ERef.nativeElement.contains(event.target))
           this.standChooseChange.emit(true);
        else {
            this.standChooseChange.emit(false);
            this.planogramQuery = '';
        }
    }

    scrolling = () => {
        this.standChooseChange.emit(false);
        this.planogramQuery = '';
    }

    @Input('standChoose') set inputStandChoose(value: boolean) {
        this.standChoose = value;
        setTimeout(() => {
            if (value) {
                document.addEventListener('click', this.clickOut);
                document.addEventListener('wheel', this.clickOut);
                window.addEventListener('resize', () => this.setCoordinates());
            }
            else {
                document.removeEventListener('click', this.clickOut);
                document.removeEventListener('wheel', this.scrolling);
            }
        }, 0);
    }

    @Input() idStands: any[];
    @Input('blankOpen') blankOpen: boolean = true;
    @Input('position')  set positionHandler(event: LinksPosition) {
        this.position = event;
        this.setCoordinates();
    };


    @Output() standChooseChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild('linkContainer', { static: true }) container :ElementRef;

    ngOnInit() {
        this.filteredPlanogram = [...this.idStands];
    }

    searchPlan() {
        this.filteredPlanogram = this.planogramQuery.length
            ? this.idStands.filter(p => p.name.toLowerCase().includes(this.planogramQuery.toLowerCase().trim()))
            : [...this.idStands];
    }

    setCoordinates() {
        switch (this.position.position) {
            case 'center': {
                if (this.position.coordinates.y + 175 > window.innerHeight)
                    this.position.coordinates.y -= 189;
                this.container.nativeElement.style.top = this.position.coordinates.y + 30 + 'px';
                this.container.nativeElement.style.left = this.position.coordinates.x - 70 + 'px';
                break;
            }
            case 'bottom': {
                if (this.position.coordinates.x + this.container.nativeElement.offsetWidth > window.innerWidth)
                    this.position.coordinates.x = window.innerWidth - this.container.nativeElement.offsetWidth + 45;
                if (this.position.coordinates.y + 175 > window.innerHeight)
                    this.position.coordinates.y -= 185;
                this.container.nativeElement.style.top = this.position.coordinates.y + 30 + 'px';
                this.container.nativeElement.style.left = this.position.coordinates.x - 60 + 'px';
                break;
            }
            default: {
                this.container.nativeElement.style.top = this.position.coordinates.y + 33 + 'px';
                this.container.nativeElement.style.left = this.position.coordinates.x - 60 + 'px';
                break;
            }
        }
    }
}
